import { createIcon } from "@chakra-ui/react";

export const MarkerLogoIcon = createIcon({
  displayName: "MarkerLogoIcon",
  viewBox: "0 0 38 56",
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <g
      id="Tutor-Application"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Step-1---Location"
        transform="translate(-593.000000, -726.000000)"
        fill-rule="nonzero"
      >
        <g id="Group-7" transform="translate(515.000000, 675.000000)">
          <g id="pin-3" transform="translate(78.000000, 51.000000)">
            <path
              d="M19,0 C8.50664647,0 0,8.60772057 0,19.2259054 C0,30.6963067 14.3870459,51.9897843 18.1225353,55.6393701 C18.6146465,56.12021 19.3853424,56.12021 19.8775206,55.6393701 C23.6130212,51.9897956 38,30.6963067 38,19.2259054 C38,8.60772057 29.4933535,0 19,0 Z"
              id="Shape"
              fill="#F45A4B"
            ></path>
            <circle id="Oval" fill="#FFFFFF" cx="19" cy="19" r="7"></circle>
          </g>
        </g>
      </g>
    </g>
  ),
});
